import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FilePickerIconComponent} from "./file-picker-icon/file-picker-icon.component";
import {IonicModule} from "@ionic/angular";
import {FormatFileSizePipe} from "../pipes/format-file-size.pipe";
import {HomePopOverComponent} from "./home-pop-over/home-pop-over.component";
import {ClientHomeMenuComponent} from "./client/client-home-menu.component";
import {AgentHomeMenuComponent} from "./agent/agent-home-menu.component";
import {AgentHome3MenuComponent} from "./agent/agent-home3-menu.component";
import {AdministratorHomeMenuComponent} from "./administrator/administrator-home-menu.component";
import {UsersComponent} from "./lists/users/users.component";
import {ContractsComponent} from "./lists/contracts/contracts.component";
import {BonusesComponent} from "./lists/bonuses/bonuses.component";
import {ClientsComponent} from "./lists/clients/clients.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ClientSideMenuComponent} from "./client/client-side-menu.component";
import {AdministratorSideMenuComponent} from "./administrator/administrator-side-menu.component";
import {ClientContractsComponent} from "./lists/client-contracts/client-contracts.component";
import {UserBonusesComponent} from "./user-bonuses/user-bonuses.component";
import {EditContractPageModule} from "../edit-contract/edit-contract.module";
import {PaymentsComponent} from "./lists/payments/payments.component";
import {ExtendContractModalComponent} from "./administrator/extend-contract-modal/extend-contract-modal.component";
import {PipesModule} from "../pipes/pipes.modules";
import {ComingSoonComponent} from "./coming-soon/coming-soon.component";
import {AddBookmarkComponent} from "./add-bookmark/add-bookmark.component";
import {SupportChatComponent} from "./support-chat/support-chat.component";
import {EditPaymentComponent} from "./edit-payment/edit-payment.component";
import {AmplifyAuthenticatorModule} from "@aws-amplify/ui-angular";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {NewTicketComponent} from "./new-ticket/new-ticket.component";
import { UploadFilesComponent } from './upload-files/upload-files.component';
import { FilePickerItemComponent } from './file-picker-item/file-picker-item.component';

@NgModule({
    declarations: [
        FilePickerIconComponent,
        FormatFileSizePipe,
        HomePopOverComponent,
        ClientHomeMenuComponent,
        UsersComponent,
        ContractsComponent,
        BonusesComponent,
        ClientsComponent,
        AgentHomeMenuComponent,
        AgentHome3MenuComponent,
        ClientContractsComponent,
        AdministratorHomeMenuComponent,
        ClientSideMenuComponent,
        AdministratorSideMenuComponent,
        UserBonusesComponent,
        PaymentsComponent,
        ExtendContractModalComponent,
        AddBookmarkComponent,
        ComingSoonComponent,
        SupportChatComponent,
        EditPaymentComponent,
        ChangePasswordComponent,
        NewTicketComponent,
        UploadFilesComponent,
        FilePickerItemComponent,
    ],
    imports: [IonicModule, CommonModule, FormsModule, PipesModule, FormsModule,
        ReactiveFormsModule, AmplifyAuthenticatorModule],
    exports: [
        FilePickerIconComponent,
        HomePopOverComponent,
        FormatFileSizePipe,
        ClientHomeMenuComponent,
        AgentHomeMenuComponent,
        AgentHome3MenuComponent,
        AdministratorHomeMenuComponent,
        UsersComponent,
        ContractsComponent,
        BonusesComponent,
        ClientsComponent,
        ClientContractsComponent,
        ClientSideMenuComponent,
        AdministratorSideMenuComponent,
        UserBonusesComponent,
        PaymentsComponent,
        ComingSoonComponent,
        AddBookmarkComponent,
        SupportChatComponent,
        EditPaymentComponent,
        ChangePasswordComponent,
        NewTicketComponent,
        UploadFilesComponent
    ],
})
export class SharedComponentsModule {
}
